<template>
  <div id="app">
    <TopNavbar class="MobileHide"/>
    <Navbar />
    <router-view :key="$route.path" />
    <Footer />
  </div>
</template>

<script>
// import { mapActions, mapGetters} from 'vuex';
import Navbar from './components/Navbar';
import TopNavbar from './components/TopNavbar';
import Footer from './views/Landing/Footer.vue';

export default {
  name: 'App',
    metaInfo: {
    title: 'End-To-End Hotel Solutions',
    titleTemplate: 'Protel %s',
    htmlAttrs: {
      lang: 'en-US'
    },
    meta: [
      { charset: 'utf-8' },
      { name: 'description', content: 'Find out how protel’s Property Management System (PMS) can help you improve you overall hotel performance from booking reservations, check-in, housekeeping, to invoicing.' },
    ]
  },
  data(){
    return {
    }
  },

  async mounted(){
    
   
  },

  methods:{

  },

  components: {
   Navbar,
   TopNavbar,
   Footer,
  },
  
}
</script>

<style>
@import url('https://fonts.googleapis.com/css2?family=Archivo:wght@300;400;600;700&display=swap');

#app {
  font-family: 'Archivo', sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
}

@media only screen and (max-width: 995px) {
  .MobileHide {
    display: none;
  }
}

</style>
